import { useMotionStudioModalBase } from 'modules/campaigns/modules/creative-creator/components/VariationsCreation/hooks/useMotionStudioModalBase';

export const useMotionStudioModal = props => {
    return useMotionStudioModalBase({ ...props });
};
